const PoweredBy: React.FC = () => {
  return (
    <p className='powered-by'>
      Powered by{' '}
      <a
        target='_blank'
        className='powered-by-link'
        href='https://conversed.ai'
        rel='noreferrer'>
        Conversed.ai
      </a>
    </p>
  );
};

export default PoweredBy;
